import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgX = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 18,
	viewBox: "0 0 19 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.1504 4.5L5.15039 13.5",
		stroke: "#2A2B2F",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.15039 4.5L14.1504 13.5",
		stroke: "#2A2B2F",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export { SvgX as ReactComponent };
